const themeOptions = {
  palette: {
    mode: "light",
    primary: {
      main: "#71c2a9",
    },
    secondary: {
      main: "#ec9c26",
    },
    background: {
      default: "#f7e5ae",
      paper: "#f7e5ae",
    },
    error: {
      main: "#75280f",
    },
    success: {
      main: "#71c2a9",
    },
    warning: {
      main: "#de731d",
    },
  },
} as const;

export default themeOptions;


